import bubblechatLocaleEn from './locales/bubblechat/locale-en.json';
import bubblechatLocaleJa from './locales/bubblechat/locale-ja.json';
import bubblechatLocaleKo from './locales/bubblechat/locale-ko.json';
import bubblechatLocaleTh from './locales/bubblechat/locale-th.json';
import bubblechatLocaleZh from './locales/bubblechat/locale-zh.json';
import tingleLocaleEn from './locales/tingle/locale-en.json';
import tingleLocaleJa from './locales/tingle/locale-ja.json';
import tingleLocaleKo from './locales/tingle/locale-ko.json';
import tingleLocaleTh from './locales/tingle/locale-th.json';
import tingleLocaleZh from './locales/tingle/locale-zh.json';
import { serviceName } from './translation';

/**
 * 정적 로케일 aggregate — reward-service·design-system 전용 딥 경로 모듈.
 *
 * chat 계열(bubblechat-web·tingle-web)은 translation.ts 의 지연 로더(loadLocaleResource)를
 * 쓴다(초기 번들 축소 P1 — 부팅 폐쇄에서 로케일 raw 2.5MB 제거).
 *
 * ⚠️ index.ts 배럴로 re-export 금지 — 배럴을 경유하면 chat 앱들의 초기 정적 폐쇄에 로케일
 * 10개가 재유입된다(P1 회귀). 소비처는 반드시 `@repo/constants/translationStatic` 딥 경로로
 * import 할 것(package.json exports 서브패스).
 */
export const SERVICE_RESOURCES = {
  bubblechat: {
    en: { translation: bubblechatLocaleEn },
    ko: { translation: bubblechatLocaleKo },
    th: { translation: bubblechatLocaleTh },
    zh: { translation: bubblechatLocaleZh },
    ja: { translation: bubblechatLocaleJa },
  },
  tingle: {
    en: { translation: tingleLocaleEn },
    ko: { translation: tingleLocaleKo },
    th: { translation: tingleLocaleTh },
    zh: { translation: tingleLocaleZh },
    ja: { translation: tingleLocaleJa },
  },
};

export const resources = SERVICE_RESOURCES[serviceName] || SERVICE_RESOURCES.bubblechat;
